import { apiCall } from "./service";
import {
  URL_SEARCH_CONTACTS,
  URL_VIEW_CONTACTS,
  URL_LIST_CONTACTS,
  URL_CREATE_CONTACT,
  URL_UPDATE_CONTACT,
  URL_DELETE_CONTACT,
} from "./URL";

export const api = {
  getContacts(parentType, parentId) {
    return apiCall.get({ url: `${URL_LIST_CONTACTS(parentType, parentId)}` });
  },

  // Lightweight typeahead search (own + shared ancestors) - used by ContactsSelect.
  // forNewChild: treat parentType/parentId as a stand-in ancestor for a not-yet-created child
  // (e.g. picking a Sponsor while creating a new Project) - only that node's shared contacts
  // are visible then, never its full unfiltered list.
  searchContacts(parentType, parentId, searchTerm, forNewChild = false) {
    const query = `${URL_SEARCH_CONTACTS(parentType, parentId)}${searchTerm || ""}`;
    return apiCall.get({
      url: forNewChild ? `${query}&forNewChild=true` : query,
    });
  },

  // Own contacts + shared ancestors + descendant rollup - the Contacts panel's data source
  getViewContacts(parentType, parentId, searchTerm) {
    const query = searchTerm ? `?searchTerm=${searchTerm}` : "";
    return apiCall.get({
      url: `${URL_VIEW_CONTACTS(parentType, parentId)}${query}`,
    });
  },

  createContact(parentType, parentId, payload) {
    return apiCall.post({
      url: `${URL_CREATE_CONTACT(parentType, parentId)}`,
      params: payload,
    });
  },

  updateContact(parentType, parentId, contactId, payload) {
    return apiCall.put({
      url: `${URL_UPDATE_CONTACT(parentType, parentId, contactId)}`,
      params: payload,
    });
  },

  deleteContact(parentType, parentId, contactId, hardDelete = false) {
    return apiCall.delete({
      url: `${URL_DELETE_CONTACT(parentType, parentId, contactId, hardDelete)}`,
    });
  },
};

export default api;
